import {createReducer, on} from '@ngrx/store';
import {initialAppNavigationState} from './app-navigation.state.initial';
import {AppNavigationActions} from './app-navigation.actions';


export const appNavigationReducer = createReducer(
  initialAppNavigationState,

  on(
    AppNavigationActions.enableButton,
    (state, {buttonId}) => ({
      ...state,
      buttonStates: {
        ...state.buttonStates,
        [buttonId]: true,
      },
    })
  ),

  on(
    AppNavigationActions.disableButton,
    (state, {buttonId}) => ({
      ...state,
      buttonStates: {
        ...state.buttonStates,
        [buttonId]: false,
      },
    })
  ),

  on(
    AppNavigationActions.setButtonEnabled,
    (state, {buttonId, enabled}) => ({
      ...state,
      buttonStates: {
        ...state.buttonStates,
        [buttonId]: enabled,
      },
    })
  ),

  on(
    AppNavigationActions.setAllButtonsEnabled,
    (state, {enabled}) => {
      const updatedStates: { [key: string]: boolean } = {};
      Object.keys(state.buttonStates).forEach(buttonId => {
        updatedStates[buttonId] = enabled;
      });
      return {
        ...state,
        buttonStates: updatedStates,
      };
    }
  ),
);
